import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">精彩视频</h2>
          <p className="text-sm text-foreground-600 mt-3">独家访谈与深度解析，视觉化呈现吃瓜现场</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-accent-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/60 text-xs text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}